import React, { Component } from 'react';
import { connect } from 'react-redux'
import Table from 'react-bootstrap/Table';
import Navbar from './Navbar'
import { Link } from 'react-router-dom'



class Confirm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            id: localStorage.getItem('idOrder'),
            orderDetails: [],
            itemDetails: []
        }
    }

    componentDidMount() {
        fetch(this.props.commonUrl+'paymentShoppingCart.php?idOrder=' + localStorage.getItem('idOrder'))
            .then((response) => {
                return response.json();
            }).then(data => {
                this.setState({ orderDetails: data.orderDetails })
                this.setState({ itemDetails: data.itemDetails })
            });
        localStorage.clear();
    }


    render() {
        return (
            <div>
                <Navbar isAuthed={false} /><div class="container"><br />
                    <Link name="mainMenu" class="btn mainMenu " to="/"><b> {"<"} Main Menu</b> </Link>
                    {this.state.orderDetails.status != "Saved" ?
                        <div >
                            <h5 class="alert alert-success"> You Order has been Confirmed. Thank you for your order</h5>
                            <p><b>Order Confirmation Details</b></p>
                            <span><strong>Confirmation# : {this.state.orderDetails.confirmationNumber} </strong></span><br />
                            <span><strong>Order# : {this.state.orderDetails.idOrder} </strong></span><br />
                            <span><strong>Ordered By :  {this.state.orderDetails.firstName} </strong></span> <br />

                            <span><strong>Pickup/Delivery Details: {this.state.orderDetails.pickupDate} {this.state.orderDetails.pickupTime ? ", " + this.state.orderDetails.pickupTime+ " at The Bakery"  : ""}  </strong></span><br />
                            <span><strong>Amount Paid: ${this.state.orderDetails.orderSubTotal} </strong></span><br />
                            <span><strong>Comments: {this.state.orderDetails.allergyInfo} </strong></span><br />
                            <span><strong>Items Ordered :</strong></span>
                            <table>
                                <thead><tr>
                                    <th>Item</th>
                                    <th>Selection</th>
                                    <th>Custom Message</th>
                                    <th>Quantity</th>
                                </tr></thead>
                                {this.state.itemDetails.map((itemDetail) => {
                                    return <tbody>

                                        <tr>
                                            <td>{itemDetail.title}</td>
                                            <td>{itemDetail.toppings}</td>
                                            <td>{itemDetail.comments}</td>
                                            <td>{itemDetail.quantity}</td></tr>


                                    </tbody>
                                })}
                            </table>
                        </div>
                        :
                        <h5 class="materialert danger"> Sorry !! We cannot process your order right now.</h5>

                    }
                </div>
            </div>

        )
    }


} export default Confirm